<template>
  <div>
    <div class="group" :class="colorChng">
      <input
        :type="type"
        :name="name"
        :value="value"
        :id="customid"
        :class="cclass"
        :style="cstyle"
        :test-val="val"
        @keyup="validation(val)"
        required>

        <span class="highlight"></span>
        <span class="bar"></span>
        <label>{{label}}</label>
    </div>
  </div>
</template>

<script>
  /*
How to use
<c-input
	cclass="class for input"
	type="input type" * OBLIGATORIO
	name="name for input (remember to add if going to submit)"
	val="typeOfValidation|Min|Max"  ----  val="numeric|5|10"
	label="Nombre (Completo)" * OBLIGATORIO
	cid="id of input"
	cstyle="custom style"
	value="default value of input"
></c-input>
*/

/*
<-- validation methods -->
name
number|min|max
not-req-number|0|max
email
verify_email (requires an input with id="email")
select
next (added to buttons for Next page if any error will not let you continue)
back-error (same as next)
required (if empty or value less than 1 will cause error)
document-image (same as required)
alpha-numeric|min|max

*/

  var $ = require('jquery')

  export default {
    props: ['type', 'name', 'value', 'cclass', 'val', 'cid', 'label', 'cstyle', 'parClass', 'colorChng'],
    data() {
      return {
        customid: (this.cid) ? this.cid : this._uid,
        customStyle: this.cstyle
      }
    },
    methods: {
      validation(val) {
        var input = $('#' + this.customid)
        var inputValue = $('#' + this.customid).val()
        this.$emit('getVal', inputValue)
        val = val.split('|')
        var type = val[0]
        var min = val[1]
        var max = val[2]
        if (min === undefined) { min = 1 }
       //  if (max === undefined) { max = '' }

        switch (type) {
          case 'name':
            if (inputValue === '' || inputValue.length <= 1) {
              $(input).addClass('error')
            } else {
              $(input).removeClass('error')
            }
            break

          case 'number':
            if ($.isNumeric(inputValue)) {
              input.attr('maxlength', max)
              if (inputValue.length < min) {
                input.addClass('error')
              }
              if (inputValue.length >= min) {
                input.removeClass('error')
              }
            } else {
              $(input).addClass('error')
              input.val('')
            }
            break

          case 'not-req-number':
            if ($.isNumeric(inputValue)) {
              input.attr('maxlength', max)
            } else {
              input.val('')
            }
            break

          case 'email':
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (!re.test(inputValue)) {
              $(input).addClass('error')
            } else {
              $(input).removeClass('error')
            }

            break

          case 'verify_email':
            var email = $('#email').val()
            if (inputValue !== email) {
              $(input).addClass('error')
            } else {
              $(input).removeClass('error')
            }

            break

          case 'select':
            if ($(input).prop('selectedIndex') !== 0) {
              $(input).removeClass('error')
            } else {
              $(input).addClass('error')
            }
            break

          case 'next':
            var i = 0
            $('form input, form select, .error-check-img-cont').each(function (index, input) {
              if ($(input).hasClass('error')) {
                i = input
                return false
              }
            })
            if (i !== 0) {
              var offset = $(input).offset()
              offset.left -= 200
              offset.top -= 200
              $('html, body').animate({
                scrollTop: offset.top,
                scrollLeft: offset.left
              })
              input.scrollIntoView(true)
              input.focus()
              return i
            }
            break

          case 'back-error':
            val = 0
            $('form input, form select, .error-check-img-cont').each(function (index, input) {
              if ($(input).hasClass('error')) {
                var offset = $(input).offset()
                offset.left -= 200
                offset.top -= 200
                $('html, body').animate({
                  scrollTop: offset.top,
                  scrollLeft: offset.left
                })
                input.scrollIntoView(true)
                input.focus()
                return false
              }
            })

            if (val !== 0) {
              return val
            }
            break

          case 'required':

            if (inputValue === '' || inputValue.length < 1) {
              $(input).addClass('error')
            } else {
              $(input).removeClass('error')
            }

            break


          case 'document-image':

            if (inputValue === '' || inputValue.length < 1) {
              $(input).addClass('error')
            } else {
              $(input).removeClass('error')
            }

            break

          case 'alpha-numeric':

            re = /^[a-z0-9]+$/i
            input.attr('maxlength', max)
            if (inputValue.length < min) {
              $(input).addClass('error')
            } else if (!re.test(inputValue)) {
              $(input).addClass('error')
            } else {
              $(input).removeClass('error')
            }
            break
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import '~varmix';
  /* form starting stylings ------------------------------- */
  $color1: $amarilloL;   // change for custom colors
  $color2: $amarilloO;

  $color3: $amarilloL;
  $color4: gray;

  $bg: transparent;
  .group {
    position: relative;
    margin-bottom: 30px;
    margin-top: 30px;
  }

  input {
    // margin: 30px;
    font-size: 18px;
    padding: 10px 10px 10px 5px;
    display: block;
    width: 100%;
    border: none;
    border-bottom: 1px solid $color1;
    background-color: $bg;
  }

  input:focus {
    outline: none;
  }
  /* LABEL ======================================= */

  label {
    color: $color2;
    font-size: 18px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 10px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }
  /* active state */

  input:focus ~ label,
  input:valid ~ label {
    top: -20px;
    font-size: 14px;
    color: $color2;
  }
  /* BOTTOM BARS ================================= */

  .bar {
    // position: relative;
    display: block;
    width: 100%;
  }

  .bar:before,
  .bar:after {
    content: '';
    height: 2px;
    width: 0;
    bottom: 1px;
    position: absolute;
    background: $color1;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }

  .bar:before {
    left: 50%;
  }

  .bar:after {
    right: 50%;
  }
  /* active state */

  input:focus ~ .bar:before,
  input:focus ~ .bar:after {
    width: 50%;
  }
  /* HIGHLIGHTER ================================== */

  .highlight {
    position: absolute;
    height: 60%;
    width: 100px;
    top: 20%;
    left: 0;
    pointer-events: none;
    opacity: 0.5;
  }
  /* active state */

  input:focus ~ .highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
  }
  /* ANIMATIONS ================ */

  @-webkit-keyframes inputHighlighter {
    from {
      background: $color1;
    }
    to {
      width: 0;
      background: transparent;
    }
  }

  @-moz-keyframes inputHighlighter {
    from {
      background: $color1;
    }
    to {
      width: 0;
      background: transparent;
    }
  }

  @keyframes inputHighlighter {
    from {
      background: $color1;
    }
    to {
      width: 0;
      background: transparent;
    }
  }
  /*  CENTER PLACEHOLDER */

  .center-placeholder::-webkit-input-placeholder {
    text-align: center;
  }

  .center-placeholder:-moz-placeholder {
    /* Firefox 18- */
    text-align: center;
  }

  .center-placeholder::-moz-placeholder {
    /* Firefox 19+ */
    text-align: center;
  }

  .center-placeholder:-ms-input-placeholder {
    text-align: center;
  }

  .error {
    border: 2px solid black !important;
    border-bottom-color: white;
  }

  .changeColor{

  input{
    border-color: $color3;
  }
  label{
    color: $color4;
  }
  input:focus ~ label,
  input:valid ~ label {
    color: $color4;
  }
  .bar:before,
  .bar:after {
    color: $color3
  }
   @-webkit-keyframes inputHighlighter {
    from {
      background: $color3;
    }
    to {
      width: 0;
      background: transparent;
    }
  }

  @-moz-keyframes inputHighlighter {
    from {
      background: $color3;
    }
    to {
      width: 0;
      background: transparent;
    }
  }

  @keyframes inputHighlighter {
    from {
      background: $color3;
    }
    to {
      width: 0;
      background: transparent;
    }
  }

}
</style>





// WEBPACK FOOTER //
// Input.vue?10e8a2df